import { PrintOutlined } from '@mui/icons-material'
import { Modal } from 'antd'
import React, { useState } from 'react'
import { useRef } from 'react'
import { useReactToPrint } from 'react-to-print'
import { getDataSheet, getQuestion, showTextEmpty } from '../../../helpers/textValidation'

const QuestionaireDataSheet = React.forwardRef(({ QuestionnaireData, DataSheetData, DataSheetDataEmergency, handleCloseQuesModal, onCancelDataSheetModal, OpenQuesModal, setOpenQuesModal, isDataSheetModalOpen, setisDataSheetModalOpen, ref }) => {

    const questionModalContent = getQuestion(QuestionnaireData)
    const dataSheetContent = getDataSheet(DataSheetData, DataSheetDataEmergency);
    const componentRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    return (
        <>
            <Modal mask={false} open={OpenQuesModal} onOk={() => { }} onCancel={handleCloseQuesModal} footer={false} title={false} closable={true} closeIcon={<></>} width={800}>
                <div ref={componentRef}>
                    <div id="ques-print-head" style={{ display: "flex", gap: "1px", alignItems: "center", justifyContent: "space-between", padding: "5px", borderRadius: "5px" }}>
                        <span style={{ fontSize: "15px", fontWeight: "bold" }}>Questionnaire</span>
                        <span style={{ fontSize: "15px" }} onClick={() => setOpenQuesModal(false)}>X</span>
                    </div>
                    <div className="new-hire-queue-details-questionnaire" id="Que-GFG">
                        <span id="kchbhe" style={{ fontSize: "15px", fontWeight: "bold", backgroundColor: '#2963AD', color: 'white', padding: '11px', borderRadius: '10px' }}>{DataSheetData?.id + " / " + DataSheetData?.firstName + " " + showTextEmpty(DataSheetData?.middleName) + " " + DataSheetData?.lastName}</span>
                        {questionModalContent?.map(x => <div className="content" >
                            <div>{x?.head}</div>
                            <div style={{ fontWeight: "bold" }}>{x?.value}</div>
                        </div>)}
                    </div>
                </div>

                <div style={{ display: "flex", flexDirection: "column", gap: "", alignItems: "center", justifyContent: "center" }}>
                    <button
                        className='btn-modal'
                        style={{ background: '#2963AD', width: '30%', color: 'white', height: '40px', borderRadius: '10px', border: 'none', cursor: "pointer", display: "flex", alignItems: "Center", justifyContent: "Center", gap: "10px" }}
                        onClick={() => handlePrint()}>
                        Print <PrintOutlined />
                    </button>
                </div>

            </Modal>
            <Modal open={isDataSheetModalOpen} onOk={() => { }} onCancel={onCancelDataSheetModal} footer={false} title={false} closable={true} closeIcon={<></>} width={800}>
                <div ref={componentRef}>

                    <div id="ques-print-head" style={{ display: "flex", gap: "10px", alignItems: "center", justifyContent: "space-between" }}>
                        <span style={{ fontSize: "15px", fontWeight: "bold" }}>Data Sheet</span>
                        <span style={{ fontSize: "15px" }} onClick={() => setisDataSheetModalOpen(false)}>X</span>
                    </div>
                    <div className="new-hire-queue-details-questionnaire" id="DS-GFG">
                        <span style={{ fontSize: "15px", fontWeight: "bold", background: '#2963AD', color: 'white', padding: '11px', borderRadius: '10px' }}>{DataSheetData?.id + " / " + DataSheetData?.firstName + " " + showTextEmpty(DataSheetData?.middleName) + " " + DataSheetData?.lastName}</span>

                        {dataSheetContent?.map(x => <div className="content" >
                            <div>{x?.head}</div>
                            <div style={{ fontWeight: "" }}>{x?.value}</div>
                        </div>)}
                    </div>
                </div>

                <div style={{ display: "flex", flexDirection: "column", gap: "10px", alignItems: "center", justifyContent: "center" }}>
                    <button
                        className='btn-modal'
                        style={{ background: '#2963AD', width: '30%', color: 'white', height: '40px', borderRadius: '10px', border: 'none', cursor: "pointer", display: "flex", alignItems: "Center", justifyContent: "Center", gap: "10px" }}
                        onClick={() => handlePrint()}>
                        Print <PrintOutlined />
                    </button>
                </div>
            </Modal>
        </>
    )
}
)
export default QuestionaireDataSheet